/**
 * list-accordion
 */

export function category_list_accordion() {

  document.querySelectorAll('.cat-item[data-child="true"]').forEach(item => {
    item.addEventListener('click', function() {
      // 現在のdata-openの状態を取得
      const isOpen = this.getAttribute('data-open') === 'true';

      // data-open属性をトグル
      this.setAttribute('data-open', String(!isOpen));

      // aria-expanded属性を更新（アクセシビリティ向上のため）
      this.setAttribute('aria-expanded', String(!isOpen));

      // サブメニューの表示状態をトグル
      this.querySelector('.children').setAttribute('aria-hidden', String(isOpen));
    });
  });

}
